export enum SearchType {
  channel = "channel",
  radio = "radio",
  user = "user",
}
